import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { Content } from '@radix-ui/react-accordion';
import accordionStyles from './Accordion.styles.esm.js';
import { useAccordionContext } from './AccordionContext.esm.js';
import { cn } from '../../utils/cn.esm.js';

// Create AccordionContent subcomponent
const AccordionContent = React__default.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    // Access context
    const { variant, inverse } = useAccordionContext();
    const { contentWrapper, content } = useMemo(() => accordionStyles({ variant, inverse }), [variant, inverse]);
    return (jsx(Content, Object.assign({ ref: ref, className: cn(contentWrapper(), className) }, props, { children: jsx("div", { className: content(), children: children }) })));
});

export { AccordionContent };
